import {useEffect} from "react";
import axios from "axios";
import {flushQueue} from "./frontStatsQueue";

const FLUSH_INTERVAL_MS = 5000;

export default function FrontStats() {
    useEffect(() => {
        const interval = setInterval(() => {
            const events = flushQueue();
            if (events.length === 0) return;
            axios.post('/api/front-stats', {events}).catch(() => {});
        }, FLUSH_INTERVAL_MS);

        return () => clearInterval(interval);
    }, []);

    return null;
}
